
import React, { useContext } from 'react';
import './Cart.css';
import { StoreContext } from '../context/StoreContext';
import { useNavigate } from 'react-router-dom';

export default function Cart() {
  const { cartItems, cartPrices, additionals, removeFromCart, bev_list, getTotalCartAmount, url } = useContext(StoreContext);
  const navigate = useNavigate();

  const additionalAmount = additionals ? Object.values(additionals).reduce((acc, price) => acc + price, 0) : 0;

  return (
    <div className='cart'>
      <div className="cart-items">
        <div className="cart-items-title">
          <p>Items</p>
          <p>Title</p>
          <p>Quantity</p>
          <p>Price</p>
          <p>Total</p>
          <p>Remove</p>
        </div>
        <br />
        <hr />
        {bev_list.map((item) => {
          if (cartItems[item._id] > 0) {
            return (
              <div key={item._id}>
                <div className="cart-items-title cart-items-item">
                  <img src={`${url}/images/${item.image}`} alt="" />
                  <p>{item.name}</p>
                  <p>{cartItems[item._id]}</p>
                  <p>P{item.price}</p>
                  <p>P{item.price * cartItems[item._id]}</p>
                  <p onClick={() => removeFromCart(item._id)} className="cross">x</p>
                </div>
                <hr />
              </div>
            );
          }
        })}
        <div className="cart-bottom">
          <div className="cart-total">
            <h2>Cart Totals</h2>
            {/* <div className="cart-add">
              <p>Additionals</p>
              <p>+P{additionalAmount}</p>
            </div>
            <hr /> */}
            <div className="cart-total-details">
              <p>Subtotal</p>
              <p>P{getTotalCartAmount()}</p>
            </div>
            <hr />
            <div className="cart-total-details">
              <p>Delivery Fee</p>
              <p>+P{50}</p>
            </div>
            <hr />
            <div className="cart-total-details">
              <b>Total</b>
              <b>P{getTotalCartAmount() + 50}</b>
            </div>
            <button onClick={() => navigate('/PlaceOrder')}>CHECKOUT</button>
          </div>
        </div>
      </div>
    </div>
  );
}
